import { axiosInstance } from './common';

export const leaveOrganization = () =>
  axiosInstance.post('/organization/leave').then((response) => response.data);

export const getInviteDetails = (token) =>
  axiosInstance.get(`/invite/${token}`).then((r) => r.data);

export const acceptInvite = (token) =>
  axiosInstance.post(`/invite/accept/${token}`).then((r) => r.data);

export const declineInvite = (token) =>
  axiosInstance.post(`/invite/decline/${token}`).then((r) => r.data);
